import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const LargeRectangleIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path d="M3.59998 3.60001H20.4V20.4H3.59998V3.60001Z" fill={color} />
    </BaseIcon>
  ),
);

LargeRectangleIcon.displayName = 'LargeRectangleIcon';
